import React, { FC } from 'react';
const CopyIcon: FC = () => {
    return (
        <svg
            className={`svg-inline`}
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13 4.5332H6.33335C5.41288 4.5332 4.66669 5.2794 4.66669 6.19987V12.8665C4.66669 13.787 5.41288 14.5332 6.33335 14.5332H13C13.9205 14.5332 14.6667 13.787 14.6667 12.8665V6.19987C14.6667 5.2794 13.9205 4.5332 13 4.5332Z"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.3334 4.53353V2.86686C11.3334 2.42483 11.1578 2.00091 10.8452 1.68835C10.5327 1.37579 10.1087 1.2002 9.66671 1.2002H3.00004C2.55801 1.2002 2.13409 1.37579 1.82153 1.68835C1.50897 2.00091 1.33337 2.42483 1.33337 2.86686V9.53353C1.33337 9.97556 1.50897 10.3995 1.82153 10.712C2.13409 11.0246 2.55801 11.2002 3.00004 11.2002H4.66671"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CopyIcon;
